import React from "react";
import { apiConstants } from "../../../common/constants";
import { formatDate } from "../../../helpers/UtilityHelper";
import { useGenericPostRequestQuery } from "../../../redux/commonRTK";
import _ from 'lodash'
import WhatsaAppContext from "./Context";
import getRequestFilter, { NON_NDR_TEMPLATE_KEY } from "./filter";

// Translate the in-table filter form values into server-side `andfilter` clauses
// so paging stays correct (client-side filtering can only see the current page).
function buildExtraFilters({ templateName, awbNumber, mobileNumber, createdDate } = {}) {
    const extra = []
    if (templateName) extra.push({ field: 'template_name', operator: 'eq', value: templateName })
    if (awbNumber) extra.push({ field: 'meta_data.awbNumber', operator: 'eq', value: awbNumber })
    if (mobileNumber) extra.push({ field: 'payload_body.to', operator: 'eq', value: `+91${mobileNumber}` })
    if (createdDate) {
        const day = formatDate(createdDate, 'yyyy-MM-dd')
        extra.push({ field: 'created_date', operator: 'gte', value: `Date('${day} 00:00:00')` })
        extra.push({ field: 'created_date', operator: 'lte', value: `Date('${day} 23:59:59')` })
    }
    return extra
}

export default function useStatus({ page = 0, sizePerPage = 50, filters } = {}) {
    const { dateRange } = React.useContext(WhatsaAppContext)

    // Server-side pagination: request only the current page. `count` comes back on
    // the first page (skipCount=false) and is reused on later pages (skipCount=true).
    const requestPayload = getRequestFilter(dateRange, NON_NDR_TEMPLATE_KEY, {
        limit: sizePerPage,
        offset: page * sizePerPage,
        skipCount: page > 0,
        extraFilters: buildExtraFilters(filters),
    })

    const { data: responseData, isLoading, isFetching } = useGenericPostRequestQuery({ url: apiConstants.DELIVERY_DB_SEARCH, data: requestPayload, type: 'POST' })

    // Keep the last known total so pages that skip the count still report it.
    const countRef = React.useRef(0)
    if (responseData?.count != null) countRef.current = responseData.count

    if (isLoading || isFetching) return { isLoading: true }

    const data = _.orderBy(responseData?.data || [], 'created_date', 'desc')
    return { isLoading: false, totalSent: countRef.current, data }
}
